import moment from 'moment'

export function getTimeRange (time) {
  const [begin, end] = time || [null, null]
  return [
    begin ? +moment(begin).startOf('days') : null,
    end ? +moment(end).endOf('days') : null
  ]
}

// export function getTimeRangeFormatter (time, formatter = '') {
//   const [begin, end] = time || [null, null]
//   return [
//     begin ? moment(begin).startOf('days').format(formatter) : null,
//     end ? moment(end).endOf('days').format(formatter) : null
//   ]
// }
// export function getShortcutMonth(month) {
//   const end = +moment().subtract(0, 'month').startOf('month')
//   const start = +moment().subtract(month, 'month').startOf('month')
//   return [start, end]
// }

// export function getShortcut30 (size = 30, type = 'days') {
//   const end = +moment().subtract(0, type).endOf(type)
//   const start = +moment().subtract(size - 1, type).startOf(type)
//   return [start, end]
// }

// export const formatTimeRange = (time, prop = '', suffix = 'Date') => {
//   const [begin, end] = time || [null, null]
//   return {
//     [`begin${prop}${suffix}`]: begin ? +moment(begin).startOf('days') : null,
//     [`end${prop}${suffix}`]: end ? +moment(end).endOf('days') : null
//   }
// }
